import { render, staticRenderFns } from "./N2.vue?vue&type=template&id=8a66ecc2&scoped=true&"
import script from "./N2.vue?vue&type=script&lang=js&"
export * from "./N2.vue?vue&type=script&lang=js&"
import style0 from "./N2.vue?vue&type=style&index=0&id=8a66ecc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a66ecc2",
  null
  
)

export default component.exports